"use client";

import Image from "next/image";
import Link from "next/link";
import { motion } from "framer-motion";

interface RelatedProjectProps {
  id: string;
  title: string;
  image: string;
  slug?: string;
  index?: number;
  lang?: string;
}

export default function RelatedProject({
  id,
  title,
  image,
  slug,
  index = 0,
  lang = "en",
}: RelatedProjectProps) {
  const content = (
    <motion.div
      className="flex flex-col items-center gap-4 group cursor-pointer"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      whileHover={{ y: -4 }}
    >
      {/* Image Container */}
      <div className="relative w-full h-[260px] rounded-lg overflow-hidden">
        {image && (
          <Image
            src={image || ""}
            alt={title}
            fill
            className="object-cover transition-transform duration-500 group-hover:scale-110"
          />
        )}
      </div>

      {/* Title */}
      <h3 className="text-[#3d434c] text-center text-xl md:text-2xl font-medium leading-[30px] md:leading-[34px] tracking-[-0.72px] group-hover:text-[#1a5852] transition-colors duration-300 line-clamp-2">
        {title}
      </h3>
    </motion.div>
  );

  if (slug) {
    return <Link href={`/${lang}/projects/${slug}`}>{content}</Link>;
  }

  return content;
}
